module.exports = __webpack_public_path__ + "img/pay3.6d23f7c6.png";